const columns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Email',
    selector: (row) => row?.email_tx,
    sortable: true,
    sortField: 'email_tx',
  },
  
  {
    name: 'Number of Devices',
    selector: (row) => row?.devices,
    sortable: true,
    sortField: 'devices',
  }, 
  
];
const mobileColumns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: '# of Devices',
    selector: (row) => row?.devices,
    sortable: true,
    sortField: 'devices',
  }, 
];

export { columns, mobileColumns };
